"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Text = _interopRequireDefault(require("../Text/Text"));

require("antd/dist/antd.css");

require("./RateComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RateComponent = function RateComponent(_ref) {
  var allowHalf = _ref.allowHalf,
      allowClear = _ref.allowClear,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      value = _ref.value,
      onChange = _ref.onChange,
      className = _ref.className,
      rateClassName = _ref.rateClassName,
      hiddenValue = _ref.hiddenValue;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "rate-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_antd.Rate, {
    allowHalf: allowHalf || false,
    allowClear: allowClear || true,
    defaultValue: defaultValue || 0,
    disabled: disabled || false,
    value: value,
    onChange: onChange,
    className: className
  }), hiddenValue || /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    className: "label-bold rate-text ".concat(rateClassName ? rateClassName : "")
  }, value));
};

var _default = RateComponent;
exports["default"] = _default;